import { Box, Card, Grid, Typography } from "@mui/material";
import { getIncomeTaxNewUpdates } from "api/services/automation/income-tax";
import Table, { ColumnType } from "components/Table";
import sortHandler from "components/Table/SortHandler";
import { SortDirection } from "data/constants";
import useTitle from "hooks/useTitle";
import _ from "lodash";
import { useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { ResType } from "types";
import { Permissions } from "data/permissons";
import { usePermissions } from "context/PermissionsProvider";

const NewUpdates = () => {
    useTitle('ATOM Pro | Updates')
    const navigate = useNavigate()
    const { permissions } = usePermissions();
    const [sort, setSort] = useState<any>({});
    const { data, isLoading }: ResType = useQuery(
        ["Income-tax-new-updates", {
            sort
        }],

        getIncomeTaxNewUpdates,{
        }
    );


    const handleClick = (row) => {
        navigate(`/atom-pro/income-tax/new-updates/${row?.id}`);
    };
    console.log(data)
    const defaultColumns: Array<ColumnType> = [
        {
            key: "client.displayName",
            title: "Client",
            sort: true,
            active: false,
            direction: SortDirection.ASC, default: true,
        },
        {
            key: "id",
            title: "Return",
            render: (row) => <Typography>New :{row?.returns?.newItem?.length} Updated : {row?.returns?.updateItem?.length}</Typography>
        },
        {
            key: "id",
            title: "Forms",
            render: (row: any) => <Typography>New : {row?.forms?.newItem?.length}</Typography>
        },
        {
            key: "id",
            title: "My CA",
            render: (row: any) => <Typography>New : {row?.myCas?.newItem?.length}</Typography>
        },
        {
            key: "id",
            title: "e-Challan",
            render: (row: any) => <Typography>New : {row?.eChallan?.newItem?.length}</Typography>
        },
        {
            key: "id",
            title: "Outstanding Demand",
            render: (row: any) => <Typography>New : {row?.outstandingDemand?.newItem?.length}</Typography>
        },
        {
            key: "id",
            title: "e-Proceeding(FYA)",
            render: (row: any) => <Typography>New : {row?.eProceedingFya?.newItem?.length}</Typography>
        },
        {
            key: "id",
            title: "e-Proceeding(FYI)",
            render: (row: any) => <Typography>New : {row?.eProceedingFyi?.newItem?.length}</Typography>
        },
        {
            key: "id",
            title: "e-Proceeding(FYA) Excel",
            render: (row: any) => <Typography>New : {row?.tempNoticeFya?.newItem?.length}</Typography>
        },
        {
            key: "id",
            title: "e-Proceeding(FYI) Excel",
            render: (row: any) => <Typography>New : {row?.tempNoticeFyi?.newItem?.length}</Typography>
        }
    ]

    const [columns, setColumns] = useState(_.cloneDeep(defaultColumns));
    const handleSort = (v: any) => {
        sortHandler({
            key: v.key,
            columns,
            sortState: sort,
            setSortState: setSort,
            setColumns: setColumns,
        });
    };

    return (

        <Box sx={{ padding: 1 }} overflow="auto">
            <Table
                sx={{ pb: 0, mb: 0, height: '575px' }}
                data={data?.data || []}
                columns={columns}
                sortHandler={handleSort}
                loading={isLoading}
                onRowClick={handleClick}
            />
        </Box>
    );
};

export default NewUpdates;
